export default function DataTable({ columns, rows, keyField = 'id', empty = 'No records found' }) {
  return (
    <div className="table-wrap"><table><thead><tr>{columns.map(col => <th key={col.key}>{col.label}</th>)}</tr></thead>
      <tbody>{rows.length ? rows.map((row, index) => <tr key={row[keyField] || index}>{columns.map(col => <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>)}</tr>) : <tr><td colSpan={columns.length}><div className="table-empty">{empty}</div></td></tr>}</tbody>
    </table></div>
  );
}
